import { useNavigate } from 'react-router-dom'

import { RaiseJobForm } from '@/features/jobs/components/raise-job-form'
import { toast } from 'react-toastify'

export const RaiseJobPage = () => {
  const navigate = useNavigate()

  return (
    <div className="flex flex-col gap-6">
      <RaiseJobForm
        onCancel={() => navigate('/')}
        onSuccess={() => {
          toast.success("New job raised and added to the jobs list.")
          navigate('/')
        }}
      />
    </div>
  )
}
